// extracted by mini-css-extract-plugin
export default {"wrap":"Loading_wrap__ZX76N","grow":"Loading_grow__ENMxb"};